"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getEnumHealthyValue = getEnumHealthyValue;
exports.isEnumItem = isEnumItem;
/**
 * Check if an item has enum values (a Values mapping).
 */
function isEnumItem(metricInfo) {
  return !!metricInfo?.Values && Object.keys(metricInfo.Values).length > 0;
}

/**
 * Transitional fallback map of `HealthyValue` for known enum metrics whose
 * backend schema does not yet declare it. Keyed by metric name.
 *
 * NOTE: metric names are NOT globally unique across measurements (e.g.
 * `status` appears in several NMS measurements), but in practice the
 * status-like enum values for these names are consistent across the
 * measurements that define them. If a future measurement reuses one of
 * these names with a different enum encoding, the schema's HealthyValue
 * (which takes precedence below) is the right place to fix it.
 *
 * Metrics intentionally omitted (e.g. operating-mode, fru, enabled)
 * describe state or configuration where no value is semantically "healthy".
 *
 * TODO: remove once backend measurement schema populates HealthyValue.
 */
const HEALTHY_VALUE_FALLBACKS = {
  available: 1,
  availability: 1,
  is_running: 1,
  operational_status: 1,
  'oper-status': 1,
  'admin-status': 1,
  'entity-oper-status': 3,
  'entity-admin-status': 4,
  'module-oper-status': 2,
  'fantray-oper-status': 2,
  status: 1,
  'session-state': 6,
  'adjacency-state': 8,
  'failover-status': 4,
  alarm_state: 0,
  'audible-alarm': 2
};

/**
 * Returns the value considered healthy for an enum metric, or undefined if
 * no health interpretation applies. Prefers the metric's declared
 * HealthyValue, falling back to a small client-side override map for known
 * status-like metrics.
 */
function getEnumHealthyValue(metric, metricName) {
  if (metric?.HealthyValue !== undefined) {
    return metric.HealthyValue;
  }
  if (metricName && metricName in HEALTHY_VALUE_FALLBACKS) {
    return HEALTHY_VALUE_FALLBACKS[metricName];
  }
  return undefined;
}